import React from 'react';
import {Button, Row, Col, Input, message} from 'antd';
import {marginBottom, marginLeft, marginTop, paddingBottom, paddingTop} from "../../common/script";
import {concatInfoList} from "../../api/dataCommon";
import {sendIntent} from "../api/Api";


export default class CompanyPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            weixinName: "",
            mobile: "",
            companyName: "",
            consultContent: "",
            loading: false,
            itemList: [{
                icon: 'images/ic_company_air.png',
                desc: 'Import and export service.',
            }, {
                icon: 'images/ic_company_sea.png',
                desc: 'Shipping service.',
            }, {
                icon: 'images/ic_company_time.png',
                desc: 'Air transport, land transport, on-time door-to-door delivery, open year round, 24-hour service all year round.',
            }, {
                icon: 'images/ic_company_global.png',
                desc: 'Global supply chain customization and management services.Sincerely serve every piece of your goods.',
            }, {
                icon: 'images/ic_company_customer.png',
                desc: 'Domestic CHN, international air freight forwarder.',
            }]
        }
    }

    render() {
        return (<div>
                <div style={{position: 'relative'}} className={'flex-row width100p'}>
                    <img src={'https://qiniu.mrcargo.com/zs_company_banner.png'} alt={'zs_company_banner'}
                         className={'width100p'}/>
                    <div className={'width100p first-context font-size64 text-center'} style={marginTop(10)}>
                        <span className={'colorfff'}>Our Company</span>
                    </div>
                </div>
                <div className={'bg-f5f7fa'}>
                    <Row style={Object.assign(paddingTop(12),paddingBottom(9))} className={'font-size16'}>
                        <Col span={16} offset={4}>
                            <img src={'images/ic_big_logo.png'} alt={'ic_big_logo'}/>
                            <div className={'text-justify'} style={marginTop(4)}>ZEUS Supply Chain Management (Shanghai)
                                Co., Ltd. was established in 2016.Committed to becoming a global integrated logistics
                                company.
                            </div>
                            <div style={marginTop(3)}>Mainly engaged in international air transport business,
                                relying on its own volume growth, it maintains good relations with airlines and
                                has strong bargaining power.
                            </div>
                            <div style={marginTop(3)}>Provide all kinds of
                                logistics services in China to meet customer needs, and provide supporting
                                import and export customs clearance and domestic transportation services for
                                foreign customers.
                            </div>
                            <div style={lineView}/>
                            <div style={marginTop(3)} className={'text-justify'}>According to customers' needs, it has
                                provided air transportation services in more than 200 cities around the world. We will
                                always provide customers with high-quality integrated logistics services, including:
                            </div>
                            {
                                this.state.itemList.map((item, index) => {
                                    return <div style={marginTop(3)} className={'flex-row'} key={index}>
                                        <img src={item.icon} alt={item.icon}/>
                                        <div style={marginLeft(1)}>{item.desc}</div>
                                    </div>
                                })
                            }
                        </Col>
                    </Row>
                </div>
                <div className={'width100p font-size32 flex-col colorfff text-center bg-grep-gradient'}>
                    <div style={marginTop(4)}>A New Modern Logistics driven by technology makes shipment</div>
                    <div style={marginBottom(4)}>visibility and data-informed</div>
                </div>

                <div style={marginTop(9)} className={'font-size64 text-center'}>Contact Us</div>

                <Row style={Object.assign(marginTop(7), marginBottom(5))} className={'font-size16'}>
                    <Col span={7} offset={4}>
                        <div className={'color666666'}>If you have further questions, please let us know.</div>
                        <Input className={'radius-btn height40'} style={marginTop(4)} placeholder="Name" value={this.state.weixinName}
                               onChange={(e) => {
                                   this.inputChange(e, 'weixinName');
                               }}></Input>
                        <Input className={'radius-btn height40'} style={marginTop(4)} placeholder="Phone"
                               disabled={this.state.loading}
                               value={this.state.mobile} onChange={(e) => {
                            this.inputChange(e, 'mobile');
                        }}></Input>
                        <Input className={'radius-btn height40'} style={marginTop(4)} placeholder="Company"
                               disabled={this.state.loading}
                               value={this.state.companyName} onChange={(e) => {
                            this.inputChange(e, 'companyName');
                        }}></Input>
                        <Input.TextArea className={'radius-btn'} style={marginTop(4)} placeholder="Message"
                                        autoSize={{minRows: 6, maxRows: 8}}
                                        disabled={this.state.loading}
                                        value={this.state.consultContent} onChange={(e) => {
                            this.inputChange(e, 'consultContent');
                        }}></Input.TextArea>
                        <Button type="primary" shape="default" size={'large'}
                                className={'concat-btn'} loading={this.state.loading}
                                disabled={!this.state.weixinName || !this.state.mobile || !this.state.companyName || !this.state.consultContent}
                                style={marginTop(5)} onClick={() => {
                            this.sendIntentForServer();
                        }}>Contact Us</Button>
                    </Col>
                    <Col span={8} offset={1}>
                        {
                            concatInfoList.map((item, index) => {
                                return <Row key={`concatInfoList${index}`} style={marginTop(index===0?6:5)}>
                                    <Col span={4} className={'colorDefault'}>{item.label}：</Col>
                                    <Col span={16}>
                                        {
                                            item.value.map((info, infoIndex) => {
                                                return <div key={`info${infoIndex}`}>{info}</div>
                                            })
                                        }
                                    </Col>
                                </Row>
                            })
                        }
                    </Col>
                </Row>
            </div>
        );
    }

    inputChange(e, key) {
        this.setState({
            [key]: e.currentTarget.value,
        })
    }

    /**
     * 发送意向到客服端
     */
    sendIntentForServer() {
        let params = {};
        let paramsArr = ['weixinName', 'mobile', 'companyName', 'consultContent'];
        for (let item of paramsArr) {
            params[item.key] = this.state[item.key];
        }
        sendIntent(params, () => {
            this.setState({
                loading: true
            })
        }, () => {
            this.setState({
                loading: false
            })
        }).then(res => {
            message.success('Send successfully, waiting for contact');
        })
    }
}

const lineView={
    borderBottom:'1px dashed rgba(13,24,43,0.10)',
    marginTop:'24px'
}


